module.exports = __webpack_public_path__ + "img/tower-crane.ff15ff7.png";